import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { Compbaser } from "../../../components/compbaser";
import { StoreSelectorsService, UserService } from "../../../services";
import { IPlayerStatistic } from "app/interfaces";
import * as Highcharts from "highcharts/highstock";

interface IPlayerStatisticChartData {
    data?: Array<IPlayerStatistic>;
    colors?: Array<any>;
    fields?: Array<string>;
}

@Component({
    selector: "app-account-statistic",
    templateUrl: "./account-statistic.component.html",
    styleUrls: ["./account-statistic.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatisticComponent extends Compbaser implements OnInit {
    isHighcharts = typeof Highcharts === "object"; // new
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options;
    chartConstructor: string = "stockChart";
    chartDataFree = [];
    chartDataSign = [];
    chartDataPro = [];
    chartDataLite = [];

    isLoading = true;
    isReady = false;
    yAxisLabel = "Number of Users";

    colors = ['#5AA454', '#E44D25', '#aae3f5', '#CFC0BB', '#7aa3e5'];
    constructor(public storeSelector: StoreSelectorsService, public userService: UserService, private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        this.loadChart();
        // this.initChart();
    }

    private loadChart() {
        this.cod(
            this.userService.getAccountStatistic().subscribe((data) => {
                if (!data) {
                    return;
                }
                this.isLoading = false;
                data.sort((a, b) => a.date < b.date ? -1 : 1).forEach((row) => {
                    const dt = new Date(row.date).getTime();
                    this.chartDataPro.push([dt, row.pro?.created || 0]);
                    this.chartDataFree.push([dt, row.free || 0]);
                    this.chartDataLite.push([dt, row.lite?.created || 0]);
                    this.chartDataSign.push([dt, row.sign?.created || 0]);
                });
                this.createChart();
            })
        );
    }

    // private generateChartData() {
    //     this.colors = [];

    //     this.fields = this.data.fields || [];
    //     const colors = this.data.colors;
    //     const allDates = {};
    //     const labels = [];

    //     this.data.data.forEach((row, ind) => {
    //         const label = this.getLabel(row, ind + 1);

    //         // if (this.chartType === 'pie') {
    //         //     this.pieChartCounts.push({
    //         //         name: label,
    //         //         y: row.count
    //         //     });
    //         //     this.pieChartDuration.push({
    //         //         name: label,
    //         //         y: row.duration
    //         //     });
    //         // } else {

    //         //     row.group.forEach((row1) => {
    //         //         const dateKey = new Date(+row1.year, +row1.month - 1, +row1.day, +row1.hour).getTime();
    //         //         if (!allDates[dateKey]) {
    //         //             allDates[dateKey] = {};
    //         //         }
    //         //         allDates[dateKey][label] = this.isCount ? +row1.count: +row1.duration;
    //         //     });
    //         //     labels.push(label);
    //         // }
    //         this.colors.push(colors[row.uuid] || "#FFFFFF");
    //     });

    //     // if (this.chartType !== 'pie') {
    //     //     labels.forEach((label) => {
    //     //         this.dotChartData.push({
    //     //             name: label,
    //     //             id: label,
    //     //             gapSize: 5,
    //     //             marker: {
    //     //                 symbol: 'circle'
    //     //             },
    //     //             pointInterval: 3600 * 1000,
    //     //             data: Object.keys(allDates).map((key) => [parseInt(key), allDates[key][label] || null])
    //     //         });
    //     //     });
    //     // }
    // }

    private createChart() {
        this.isReady = false;
        this.cd.detectChanges();

        this.chartOptions = {
            chart: {
                alignTicks: false,
            },
            accessibility: {
                enabled: false
            },
            rangeSelector: {
                buttons: [{
                    type: 'month',
                    count: 6,
                    text: '6m',
                    title: 'View 6 Months'
                }, {
                    type: 'year',
                    count: 1,
                    text: '1y',
                    title: 'View 1 Year'
                }, {
                    type: 'year',
                    count: 2,
                    text: '2y',
                    title: 'View 2 Years'
                }, {
                    type: 'all',
                    count: 1,
                    text: 'All'
                }],
                selected: 0,
                allButtonsEnabled: true,
                inputEnabled: false,
            },

            title: {
                text: "User Accounts Statistic",
            },
            yAxis: {
                title: {
                    text: 'Users'
                }
            },
            xAxis: {
                type: 'datetime',
                title: {
                    text: 'Month'
                },
                minRange: 4 * 30 * 24 * 3600 * 1000,
                minTickInterval: 30 * 24 * 3600 * 1000,
                labels: {
                    format: '{value:%Y-%m}'
                },
                startOnTick: true,
                endOnTick: true,
                showLastLabel: true,
                gridLineWidth: 1,
                units: [
                    [
                        'month',
                        [1, 2, 3, 4, 6, 12]
                    ],
                    [
                        'year',
                        [1, 2]
                    ]
                ]
            },
            time: {
                useUTC: false
            },
            legend: {
                enabled: true
            },
            credits: {
                enabled: false
            },
            colors: this.colors,
            plotOptions: {
                series: {
                    /* compare: 'percent', */
                    showInNavigator: true
                }
            },
            // tooltip: {
            //     pointFormat: this.yAxisLabel + ': {point.y}'
            // },
            series: [
                {
                    type: "column",
                    name: "Pro",
                    data: this.chartDataPro,
                },
                {
                    type: "column",
                    name: "Sign",
                    data: this.chartDataSign,
                    // dataGrouping: {
                    //     units: [
                    //         ["year", [1]],
                    //     ],
                    // },
                },
                {
                    type: "column",
                    name: "Lite",
                    data: this.chartDataLite,
                    // dataGrouping: {
                    //     units: [
                    //         ["year", [1]],
                    //     ],
                    // },
                },
                {
                    type: "column",
                    name: "Free",
                    data: this.chartDataFree,
                    // dataGrouping: {
                    //     units: [
                    //         ["year", [1]],
                    //     ],
                    // },
                },
            ],
        };

        // if (this.chartType === 'pie') {
        //     const _options = {
        //         chart: {
        //             type: 'pie',
        //         },
        //         credits: {
        //             enabled: false
        //         },
        //         colors: this.colors,
        //         plotOptions: {
        //             series: {
        //                 allowPointSelect: false,
        //                 cursor: 'pointer',
        //                 dataLabels: [{
        //                     enabled: false,
        //                 }],
        //                 showInLegend: false
        //             }
        //         },
        //         accessibility: {
        //             enabled: false
        //         }
        //     };

        //     // options for pie charts count
        //     this.chartOptions = {
        //         ..._options,
        //         title: {
        //             text: 'Count'
        //         },
        //         series: [
        //             {
        //                 type: 'pie',
        //                 name: 'Count',
        //                 data: this.pieChartCounts
        //             },
        //         ],
        //     };

        //     // options for pie charts duration
        //     this.chartOptions2 = {
        //         ..._options,
        //         title: {
        //             text: 'Duration'
        //         },
        //         series: [
        //             {
        //                 type: 'pie',
        //                 name: 'Duration',
        //                 data: this.pieChartDuration
        //             },
        //         ],
        //     };
        // } else {
        //     this.chartOptions = {
        //         chart: {
        //             type: 'scatter',
        //             scrollablePlotArea: {
        //                 minWidth: 600,
        //                 scrollPositionX: 1
        //             }
        //         },
        //         time: {
        //             useUTC: false
        //         },
        //         title: {
        //             text: this.yAxisLabel,
        //             align: 'center',
        //         },
        //         xAxis: {
        //             type: 'datetime',
        //             title: {
        //                 text: 'datetime'
        //             },
        //             minRange: 12 * 3600 * 1000,
        //             minTickInterval: 3600 * 1000,
        //             // labels: {
        //             //     format: '{value}'
        //             // },
        //             startOnTick: true,
        //             endOnTick: true,
        //             showLastLabel: true,
        //             gridLineWidth: 1
        //         },
        //         yAxis: {
        //             title: {
        //                 text: this.yAxisLabel
        //             },
        //             labels: {
        //                 format: '{value}'
        //             }
        //         },
        //         rangeSelector: {
        //             buttons: [{
        //                 type: 'day',
        //                 count: 1,
        //                 text: '1d',
        //                 title: 'View 1 Day'
        //             }, {
        //                 type: 'week',
        //                 count: 1,
        //                 text: '1w',
        //                 title: 'View 1 Week'
        //             }, {
        //                 type: 'all',
        //                 count: 1,
        //                 text: 'All'
        //             }],
        //             selected: 0,
        //             allButtonsEnabled: true,
        //             inputEnabled: false,
        //         },
        //         legend: {
        //             enabled: true
        //         },
        //         accessibility: {
        //             enabled: false
        //         },
        //         credits: {
        //             enabled: false
        //         },
        //         colors: this.colors,
        //         plotOptions: {
        //             scatter: {
        //                 marker: {
        //                     radius: 4,
        //                     symbol: 'circle',
        //                     states: {
        //                         hover: {
        //                             enabled: true,
        //                             lineColor: 'rgb(100,100,100)'
        //                         }
        //                     }
        //                 }
        //             },
        //             series: {
        //                 /* compare: 'percent', */
        //                 showInNavigator: true
        //             }
        //         },
        //         tooltip: {
        //             pointFormat: this.yAxisLabel + ': {point.y}'
        //         },
        //         series: this.dotChartData
        //     };
        // }

        this.isReady = true;
        this.cd.detectChanges();
    }
}
